// extracted by mini-css-extract-plugin
export default {"card":"o0-z","carouselContainer":"p0-z","carouselContent":"q0-z"};